interface LogoProps {
  className: string;
}

function Logo({ className }: LogoProps) {
  return (
    <svg
      className={className}
      width="336"
      height="118"
      viewBox="0 0 336 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M194.691 19.3672H191.439V98.7788H194.691V19.3672Z"
        fill="white"
      />
      <path
        d="M137.776 23.5391H95.1161L67.3799 70.9179L39.6437 23.5391H20.6504L62.5562 95.2032H72.2036L104.613 39.779H137.776C148.629 39.779 157.523 48.5694 157.523 59.2966C157.523 70.0239 148.629 78.8143 137.776 78.8143H122.551L113.657 95.0542H137.776C157.824 95.0542 173.953 78.9633 173.953 59.2966C173.953 39.63 157.673 23.5391 137.776 23.5391Z"
        fill="white"
      />
      <path
        d="M108.834 51.2512L97.5283 70.7689L69.7921 23.5391H50.7988L92.7046 95.2032H102.352L118.33 67.4911H134.912L144.258 51.2512H108.834Z"
        fill="white"
      />
      <path
        d="M228.824 35.0135L230.784 22.9453H234.553L231.086 42.165H227.166L224.905 30.8418L222.644 42.165H218.725L215.258 22.9453H219.177L220.986 35.0135L223.247 22.9453H226.563L228.824 35.0135Z"
        fill="white"
      />
      <path
        d="M247.062 33.8216H241.033V38.8872H248.268V42.165H236.963V22.9453H248.268V26.0741H241.033V30.6928H247.062V33.8216Z"
        fill="white"
      />
      <path
        d="M250.832 42.1656V22.7969H256.862C258.972 22.7969 260.479 23.2438 261.535 24.1378C262.59 25.0317 263.193 26.3726 263.193 28.0115C263.193 29.0544 263.042 29.7994 262.59 30.5443C262.138 31.2893 261.535 31.7363 260.781 32.0342C261.685 32.3322 262.288 32.7792 262.741 33.5241C263.193 34.2691 263.494 35.163 263.494 36.355C263.494 38.2918 263.042 39.6327 261.987 40.5267C260.932 41.4206 259.424 42.0166 257.465 42.0166H250.832V42.1656ZM254.751 30.9913H256.862C258.369 30.9913 259.123 30.2464 259.123 28.6075C259.123 27.7135 258.972 27.1176 258.52 26.6706C258.218 26.2236 257.615 26.0747 256.711 26.0747H254.751V30.9913ZM254.751 33.8221V39.0368H257.314C258.068 39.0368 258.52 38.8878 258.972 38.4408C259.273 37.9938 259.575 37.3979 259.575 36.6529C259.575 34.8651 258.972 33.9711 257.615 33.9711H254.751V33.8221Z"
        fill="white"
      />
      <path
        d="M226.262 60.9365H220.081V68.833H216.162V49.6133H227.015V52.7421H220.081V57.6587H226.262V60.9365Z"
        fill="white"
      />
      <path
        d="M233.648 49.4648H229.729V68.8335H233.648V49.4648Z"
        fill="white"
      />
      <path
        d="M250.832 68.833H246.913L241.185 56.1688V68.833H237.266V49.6133H241.185L246.913 62.2774V49.6133H250.832V68.833Z"
        fill="white"
      />
      <path
        d="M263.644 64.9592H258.217L257.162 68.982H252.941L258.971 49.6133H262.589L268.769 68.982H264.548L263.644 64.9592ZM259.122 61.6815H262.74L260.931 54.8279L259.122 61.6815Z"
        fill="white"
      />
      <path
        d="M284.598 68.833H280.679L274.95 56.1688V68.833H271.031V49.6133H274.95L280.679 62.2774V49.6133H284.598V68.833Z"
        fill="white"
      />
      <path
        d="M301.33 62.427C301.18 64.6618 300.577 66.3007 299.521 67.4926C298.315 68.6845 296.808 69.1315 294.698 69.1315C292.437 69.1315 290.778 68.3866 289.573 67.0457C288.367 65.5558 287.764 63.6189 287.764 60.9371V57.6593C287.764 54.9775 288.367 52.8916 289.573 51.5507C290.778 50.0608 292.437 49.4648 294.698 49.4648C296.808 49.4648 298.466 50.0608 299.521 51.2527C300.577 52.4446 301.18 54.0835 301.33 56.3184H297.411C297.411 54.9775 297.11 54.0835 296.808 53.4876C296.356 53.0406 295.753 52.7426 294.698 52.7426C293.643 52.7426 292.889 53.0406 292.437 53.7855C291.984 54.5305 291.834 55.7224 291.683 57.3613V60.9371C291.683 62.8739 291.834 64.2148 292.286 64.9598C292.738 65.7047 293.492 66.0027 294.547 66.0027C295.602 66.0027 296.356 65.7047 296.657 65.2578C297.11 64.8108 297.26 63.9169 297.26 62.576H301.33V62.427Z"
        fill="white"
      />
      <path
        d="M314.143 60.4901H307.962V65.5558H315.198V68.8335H304.043V49.4648H315.198V52.7426H307.962V57.3613H314.143V60.4901Z"
        fill="white"
      />
      <path
        d="M216.162 95.5015V76.1328H221.287C223.548 76.1328 225.357 76.8778 226.714 78.2187C228.071 79.7086 228.824 81.6454 228.824 84.0293V87.1581C228.824 89.6909 228.221 91.6278 226.865 93.1177C225.508 94.6076 223.699 95.3525 221.287 95.3525H216.162V95.5015ZM220.081 79.4106V92.2237H221.287C222.644 92.2237 223.548 91.9257 224.001 91.1808C224.604 90.4358 224.754 89.2439 224.905 87.605V84.1783C224.905 82.3904 224.604 81.0495 224.151 80.4535C223.699 79.8576 222.795 79.4106 221.589 79.2616H220.081V79.4106Z"
        fill="white"
      />
      <path d="M236.06 76.1328H232.141V95.5015H236.06V76.1328Z" fill="white" />
      <path
        d="M245.557 88.499H243.597V95.5015H239.678V76.1328H246.009C247.968 76.1328 249.476 76.5798 250.531 77.6227C251.586 78.6656 252.189 80.0066 252.189 81.9434C252.189 84.4763 251.285 86.2641 249.325 87.3071L252.792 95.2035V95.3525H248.571L245.557 88.499ZM243.597 85.2212H245.858C246.612 85.2212 247.215 84.9232 247.667 84.4763C248.119 84.0293 248.27 83.2843 248.27 82.3904C248.27 80.4535 247.516 79.5596 246.009 79.5596H243.748V85.2212H243.597Z"
        fill="white"
      />
      <path
        d="M265.303 87.1581H259.122V92.2237H266.358V95.5015H255.203V76.1328H266.358V79.4106H259.122V84.0293H265.303V87.1581Z"
        fill="white"
      />
      <path
        d="M282.186 89.0949C282.035 91.3298 281.432 92.9687 280.377 94.1606C279.171 95.3525 277.664 95.7995 275.553 95.7995C273.292 95.7995 271.634 95.0545 270.428 93.7136C269.222 92.2237 268.619 90.2869 268.619 87.605V84.3273C268.619 81.6454 269.222 79.5596 270.428 78.2187C271.634 76.7288 273.292 76.1328 275.553 76.1328C277.664 76.1328 279.322 76.7288 280.377 77.9207C281.432 79.1126 282.035 80.7515 282.186 82.9864H278.267C278.267 81.6454 277.965 80.7515 277.664 80.1555C277.211 79.7086 276.608 79.4106 275.553 79.4106C274.498 79.4106 273.744 79.7086 273.292 80.4535C272.84 81.1985 272.689 82.3904 272.538 84.0293V87.605C272.538 89.5419 272.689 90.8828 273.141 91.6278C273.594 92.3727 274.347 92.6707 275.402 92.6707C276.458 92.6707 277.211 92.3727 277.513 91.9257C277.965 91.4788 278.116 90.5848 278.116 89.2439H282.186V89.0949Z"
        fill="white"
      />
      <path
        d="M297.11 79.4106H292.286V95.5015H288.367V79.4106H283.543V76.1328H297.11V79.4106Z"
        fill="white"
      />
    </svg>
  );
}
export default Logo;
